<template>
  <v-dialog v-model="dialog" width="960px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("CRUD.chooseInfo", [$t("Order.title")]) }}
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
      <v-divider></v-divider>
      <!-- 搜索行 -->
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="5">
          <v-row dense align="center" class="pa-1">
            <SearcherDatetimeRange
              type="datetime"
              v-model="datetimeRage"
              :label="$t('Requisition.Fields.created_time')"
              removeIcon
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="6" align-self="center">
          <v-row dense align="center" class="search-controls">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-divider vertical />
            <v-btn
              class="caption font-weight-bold grey--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              small
              text
              @click.stop="$store.commit('toggleSearchPanel')"
            >
              {{ $t("Search.pro") }}
              <v-icon small class="ps-1">{{
                $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
              }}</v-icon>
            </v-btn>
            <v-spacer />
          </v-row>
        </v-col>
      </v-row>
      <!-- 高级搜素行 -->
      <v-expansion-panels
        v-model="$store.getters.panels"
        multiple
        flat
        accordion
      >
        <v-expansion-panel class="transparent-background-color">
          <v-expansion-panel-content>
            <v-row dense align="center">
              <v-col cols="12" sm="6" md="5">
                <SearcherKeyword
                  ref="order_code"
                  v-model="options.order_code"
                  @text="orderCodeKeyword = $event"
                  :label="$t('Order.Fields.order_code')"
                />
              </v-col>
              <v-col cols="12" sm="6" md="5">
                <SearcherMaterials v-model="materialSelected" />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <!-- 表格 -->
      <v-data-table
        :headers="headers"
        :items="Orders"
        :loading="loading"
        :options.sync="options"
        :page.sync="paging.page"
        :server-items-length="paging.count"
        multi-sort
        class="elevation-0 px-6"
        fixed-header
        height="340px"
        :footer-props="footerProps"
      >
        <template v-slot:header.action="{ header }">
          {{ header.text }}
          <v-icon x-small>fa-sliders-h</v-icon>
        </template>
        <template v-slot:item.action="{ item }">
          <div class="d-flex mt-n2 mb-n3">
            <v-btn
              color="primary"
              dense
              @click="
                $emit('confirm', item);
                dialog = false;
              "
            >
              {{ $t("Shop.Fields.choose") }}
            </v-btn>
          </div>
        </template>
        <template v-slot:item.order_price="{ item }">
          {{ $t("Global.money") }}{{ item.order_price | formatMoney }}
        </template>
        <template v-slot:item.created="{ item }">
          <span class="text-no-wrap">
            {{ item.created | formatTime }}
          </span>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          @click="dialog = false"
          class="elevation-1"
        >
          {{ $t("$vuetify.abandon") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import SearcherDatetimeRange from "@/components/plugins/SearcherDatetimeRange";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import Orders from "@/api/orders";
import SearcherMaterials from "@/components/plugins/SearcherMaterials";

const defaultOptions = {
  created_time_from:
    new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  order_code: "",
  material_ids: [],
};

export default {
  name: "DialogOrder",

  components: {
    SearcherDatetimeRange,
    SearcherKeyword,
    SearcherMaterials,
  },

  props: {
    value: Boolean,
    isActivity: Boolean,
    shopId: Number,
    isReturn: Boolean,
  },
  mounted() {
    this.getOrdersFromAPI();
  },

  computed: {
    headers() {
      return [
        {
          text: i18n.t("ReturnOrder.Order.order_code"),
          align: "start",
          sortable: false,
          value: "order_code",
        },
        {
          text: i18n.t("ReturnOrder.Order.order_price"),
          align: "start",
          sortable: false,
          value: "order_price",
        },
        {
          text: i18n.t("ReturnOrder.Order.created"),
          align: "start",
          sortable: false,
          value: "created",
        },
        {
          text: i18n.t("Shop.Fields.action"),
          align: "start",
          sortable: false,
          value: "action",
        },
      ];
    },

    footerProps() {
      return Object.assign({}, i18n.t("$config.footer-props"), {
        itemsPerPageOptions: [this.itemsPerPageOptions],
      });
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    orderCodeKeyword: "",
    dialog: false,
    options: JSON.parse(JSON.stringify(defaultOptions)),
    datetimeRage: [
      new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
        .toISOString()
        .substr(0, 10) + " 00:00:00",
      new Date().toISOString().substr(0, 10) + " 23:59:59",
    ],
    Orders: [],
    paging: {},
    itemsPerPageOptions: 5,
    loginUserId: "",
    districtID: null,
    materialSelected: [],
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
        if (this.dialog) {
          // 每次打开对话框重置查询
          this.resetSearch();
        }
      },
    },
    dialog: {
      handler() {
        if (!this.dialog) {
          this.Orders = [];
          this.paging = {};
        }
        this.$emit("input", this.dialog);
      },
    },
    options: {
      deep: true,
      handler() {
        this.getOrdersFromAPI();
      },
    },
    datetimeRage: {
      handler() {
        if (this.datetimeRage[0] == null || this.datetimeRage[0] == "") {
          this.options.created_time_from =
            new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
              .toISOString()
              .substr(0, 10) + " 00:00:00";
        } else {
          this.options.created_time_from = this.datetimeRage[0];
        }

        if (this.datetimeRage[1] == null || this.datetimeRage[1] == "") {
          this.options.created_time_to =
            new Date().toISOString().substr(0, 10) + " 23:59:59";
        } else {
          this.options.created_time_to = this.datetimeRage[1];
        }
      },
    },
    materialSelected: {
      handler() {
        this.options.material_ids = this.materialSelected
          ? this.materialSelected.map((e) => {
              return e.id;
            })
          : "";
      },
    },
  },

  methods: {
    resizeHeader() {
      this.itemsPerPageOptions = window.innerHeight > 800 ? 10 : 5;
    },

    getOrdersFromAPI() {
      let option = JSON.parse(JSON.stringify(this.options));
      option.shop_ids = [this.shopId];
      option.disable_return_flgs = [0];
      option.cancel_flgs = [0];
      if (this.isReturn) {
        option.status = [5, 6]
      }
      Orders.fetch(option).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.Orders = response.data.orders;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {
        order_code: this.orderCodeKeyword,
      });
    },
    resetSearch() {
      this.datetimeRage = [
        new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
          .toISOString()
          .substr(0, 10) + " 00:00:00",
        new Date().toISOString().substr(0, 10) + " 23:59:59",
      ];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      [this.$refs.order_code].forEach((k) => {
        if (k) k.clear();
      });
    },
  },
};
</script>
